import React from 'react';

import { CompaniesRow } from './CompaniesRow';
import type { SetErrorType } from '@/types/common';
import { useMostVisitedCompanies } from '@/hooks/useMostVisitedCompanies';
import { ROUTES } from '@/routes/routes';
import { CompanyCardsSkeletonLoggedout } from '@/components/Skeleton';
import { Company } from '@/types/graphql-types';

const LIMIT = 5;

const MostVisitedCompaniesModule: React.FC<SetErrorType> = ({ setError }) => {
  const { data, loading, error } = useMostVisitedCompanies({
    limit: LIMIT,
  });

  if (loading) return <CompanyCardsSkeletonLoggedout />;

  if (error) setError(!!error);

  const { collection } = data?.mostVisitedCompanies ?? {};

  return (
    <CompaniesRow
      title="CP_MOST_VISITED_COMPANIES_TITLE"
      showAllLink={ROUTES.mostVisitedCompanies}
      totalCaption="CP_MOST_VISITED_COMPANIES_CAPTION"
      companies={collection?.map((item) => item?.company as Company) ?? []}
    />
  );
};

export { MostVisitedCompaniesModule };
